import { profile } from 'api';

export const handleForgotPassword = async (username: string, userservice: string) => {
  await profile.post('/userlogin/forgotpassword', { username, userservice });
};
